import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchX } from "lucide-react";
import { useData } from "@/context/DataContext";
import { useLeadLog } from "@/hooks/useLeadLog";
import { nextSort, toExportParams } from "@/lib/leadLog";
import { EMPTY_FILTERS, LogFilters } from "@/components/crm/LogFilters";
import { LogTable } from "@/components/crm/LogTable";
import { ExportButton } from "@/components/crm/ExportButton";

export default function LeadLogPage() {
  const { leads, reps, repsById, today, openEditor } = useData();
  const [params] = useSearchParams();
  const [filters, setFilters] = useState(() => ({ ...EMPTY_FILTERS, flagType: params.get("flag") || "" }));
  const [sort, setSort] = useState({ key: "date_created", dir: "desc" });
  const { rows, sources, visible } = useLeadLog(leads, repsById, today, filters, sort);
  const onSort = (col) => setSort((s) => nextSort(s, col));
  const exportParams = toExportParams(filters, sort);

  return (
    <div className="space-y-5" data-testid="lead-log-page">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Lead Log</h1>
          <p className="text-sm text-slate-400">Every card field in one table. Click a row to edit.</p>
        </div>
        <div className="flex items-center justify-between gap-3 sm:justify-end">
          <p data-testid="lead-log-row-count" className="font-mono text-sm text-slate-300">{visible.length} of {rows.length} leads</p>
          <ExportButton testid="lead-log-export-btn" path="/export/leads.xlsx" params={exportParams} prefix="sales-leads" />
        </div>
      </div>
      <LogFilters filters={filters} setFilters={setFilters} reps={reps} sources={sources} />
      {visible.length === 0 ? (
        <div data-testid="lead-log-empty" className="flex flex-col items-center gap-2 rounded-2xl border border-dashed border-slate-700 bg-slate-900 py-16 text-slate-400">
          <SearchX className="h-6 w-6" /> No leads match these filters
        </div>
      ) : (
        <LogTable rows={visible} sort={sort} onSort={onSort} onOpen={openEditor} />
      )}
    </div>
  );
}
